// extracted by mini-css-extract-plugin
export var orderDetails = "_ui-2";
export var orderImage = "_ui-1";
export var orderMeta = "_ui-3";
export var orderSummary = "_ui-0";
export var rightArrow = "_ui-4";